import React from 'react'
import {
  FacebookOutlined,
  TwitterOutlined,
  InstagramOutlined,
} from '@ant-design/icons'

import { Typography } from 'antd'
export const UserInfo = ({ user, showSocialIcons }) => {
  return (
    user && (
      <div>
        <Typography.Title level={5}>
          {user.firstName} {user.lastName}
        </Typography.Title>
        <Typography.Text style={{ fontSize: '14px' }}>
          <a target="_blank" href={`/profile/${user.username}`}>
            @{user.username}
          </a>
        </Typography.Text>
        {showSocialIcons && (
          <div className="profile-card">
            {user.facebook_url && (
              <FacebookOutlined
                onClick={() => window.open(user.facebook_url, '_blank')}
              />
            )}
            {user.instagram_url && (
              <InstagramOutlined
                onClick={() => window.open(user.instagram_url, '_blank')}
              />
            )}
            {user.twitter_url && (
              <TwitterOutlined
                onClick={() => window.open(user.twitter_url, '_blank')}
              />
            )}
          </div>
        )}
      </div>
    )
  )
}
